import _typeof from "@babel/runtime/helpers/typeof";
export var Name = 'shipping-offer-dialog-result';
export var ShippingOfferDialogResultEvent = Name;
export var Result;

(function (Result) {
  Result[Result["Success"] = 0] = "Success";
  Result[Result["Cancel"] = 1] = "Cancel";
  Result[Result["Error"] = 2] = "Error";
})(Result || (Result = {}));

export var isResultType = function isResultType(data, result) {
  return _typeof(data) === 'object' && data.result === result;
};
export var isCancelResult = function isCancelResult(data) {
  return isResultType(data, Result.Cancel);
};
export var isErrorResult = function isErrorResult(data) {
  return isResultType(data, Result.Error);
};
export var isSuccessResult = function isSuccessResult(data) {
  return isResultType(data, Result.Success);
};